import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from '../history'
import {
    IconButton,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    MenuItem,
    MenuList,
    Avatar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';


import { getPhotoProfile } from '../serviceAPI/fotoPerfil/getPhotoProfile'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    icon: {
        color: theme.palette.primary.contrastText
    },
    foto: {
        width: 30,
        height: 30,
    },
}));

export default function MenuListUser(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const fotoPerfil = useSelector(state => state.fotoPerfil)

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const roleUser = props.roleUser

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    function logout() {
        localStorage.removeItem(process.env.REACT_APP_TOKENUSER)
        localStorage.removeItem(process.env.REACT_APP_USER)
        localStorage.removeItem(process.env.REACT_APP_ROLEUSER)
        history.push('/login')
    }

    function meusDados(e) {
        handleClose(e)
        history.push('/meus-dados')
    }

    function dadosProfissionais(e) {
        handleClose(e)
        history.push('/dados-profissionais')
    }

    function dadosEmpresarial(e) {
        handleClose(e)
        history.push('/dados-empresarial')
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    React.useEffect(() => {
        getPhotoProfile(dispatch);
    }, []);

    return (
        <div className={classes.root}>
            <div>
                <IconButton
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    {fotoPerfil.uri ?
                        <Avatar className={classes.foto} aria-label="recipe" src={fotoPerfil.uri} />
                        :
                        <AccountCircleIcon className={classes.icon} />
                    }
                </IconButton>
                <Popper open={open} placement={'bottom-end'} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                        <MenuItem onClick={(e) => meusDados(e)}>Meus Dados</MenuItem>
                                        {roleUser === "User" &&
                                            <MenuItem onClick={(e) => dadosProfissionais(e)}>Dados Profissionais</MenuItem>
                                        }
                                        {roleUser === "Company" &&
                                            <MenuItem onClick={(e) => dadosEmpresarial(e)}>Dados Empresarial</MenuItem>
                                        }
                                        <MenuItem onClick={() => logout()}>Logout</MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </div>
    );
}